module.exports = __webpack_public_path__ + "static/media/carousal_4_mobile.fc89a672.JPG";